import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function StripeReturn() {
  const navigate = useNavigate();

useEffect(() => {
  // 🔥 PERSIST STRIPE SUCCESS
  localStorage.setItem("stripe_success", "true");

  const timer = setTimeout(() => {
    navigate("/dashboard", { replace: true });
  }, 1200);

  return () => clearTimeout(timer);
}, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0f0a24] text-[#EB6AB5] text-lg">
      Finalizing payment & preparing your AI report…
    </div>
  );
}
